export const redirectPaths = [
  {
    path: "/life_concierge_requests",
    redirect: () => {
      return { name: "Requests" };
    },
  },
  {
    path: "/life_concierge_requests/new",
    redirect: () => {
      return { name: "Dashboard" };
    },
  },
  {
    path: "/requests/new",
    redirect: () => {
      return { name: "Dashboard" };
    },
  },
  {
    path: "/users/sign_up/:companySlug?",
    redirect: () => {
      return { name: "SignUp" };
    },
  },
  {
    path: "/users/sign_in",
    redirect: () => {
      return { name: "SignIn" };
    },
  },
];

export const externalPartnerRedirectPaths = [
  {
    path: "/products/term-life-insurance",
    alias: "/additional-information/term-life-insurance",
    redirect: () => {
      window.location.href =
        "https://www.ladderlife.com/quick-start?lddr_source=overalls&lddr_medium=website&lddr_name=recommendations";
      return { name: "SignIn" };
    },
  },
  {
    path: "/products/auto-insurance",
    alias: "/additional-information/auto-insurance",
    redirect: () => {
      window.location.href =
        "https://overalls.matic.com/auto?utm_content=segment_name&utm_medium=banner&utm_source=overalls";
      return { name: "SignIn" };
    },
  },
  {
    path: "/products/home-insurance",
    alias: "/additional-information/home-insurance",
    redirect: () => {
      window.location.href =
        "https://overalls.matic.com/home?utm_content=segment_name&utm_medium=banner&utm_source=overalls";
      return { name: "SignIn" };
    },
  },
  {
    path: "/products/home-warranty",
    alias: "/additional-information/home-warranty",
    redirect: () => {
      window.location.href =
        "https://partner.mytend.com/first-connect?subproducerID=FC96040";
      return { name: "SignIn" };
    },
  },
  {
    path: "/products/renters-insurance",
    alias: "/additional-information/renters-insurance",
    redirect: () => {
      window.location.href = "https://stillwaterinsurance.com/quoting/OVE";
      return { name: "SignIn" };
    },
  },
  {
    path: "/products/pet-insurance",
    alias: "/additional-information/pet-insurance",
    redirect: () => {
      window.location.href = "https://overalls-quote.pumpkin.care";
      return { name: "SignIn" };
    },
  },
  {
    path: "/products/wills-and-trusts",
    alias: "/additional-information/wills-and-trusts",
    redirect: () => {
      window.location.href = "https://trustandwill.sjv.io/c/5279340/851260/11883";
      return { name: "SignIn" };
    },
  },
];
